import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ReactNode, useEffect, useState } from 'react'
import { createQueryClient } from './createQueryClient'

interface ReactQueryProviderProps {
  children: ReactNode
}

export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  const [queryClient] = useState(() => createQueryClient())

  useEffect(() => {
    const unsubscribe = broadcastQueryClient({
      queryClient,
      broadcastChannel: `${process.env.OMNEA_APP_ENV}-omnea-broadcast-channel`,
    })
    return () => {
      unsubscribe()
    }
  }, [queryClient])

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" position="bottom" />
      {children}
    </QueryClientProvider>
  )
}
